export const generateArtworkAlt = ({
    title = "",
    studentName = "",
    cityName = ""
}) => {

    const cleanTitle = String(title).trim().replace(/\s+/g, " ");
    const cleanStudentName = String(studentName).trim().replace(/\s+/g, " ");
    const cleanCityName = String(cityName).trim().replace(/\s+/g, " ");

    let alt = cleanTitle || "Student artwork";

    if (cleanStudentName) {
        alt += ` created by student ${cleanStudentName}`;
    }

    if (cleanCityName) {
        alt += ` from ${cleanCityName}`;
    }

    return alt;
};